export default __webpack_public_path__ + "static/media/Edit.b430881b.svg";